import { render, staticRenderFns } from "./SolicitudesTransportes.vue?vue&type=template&id=8c48a2b2&"
import script from "./SolicitudesTransportes.vue?vue&type=script&lang=js&"
export * from "./SolicitudesTransportes.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudesTransportes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports